import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoadingPageService } from '../componentes/loading-page/loading-page.service';
import { Injectable } from '@angular/core';
import { AuthService } from '../service/autenticacao/auth.service';
import { Router } from '@angular/router';
import { PAGINA_LOGIN } from 'src/app/tools/URL';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  private requests: HttpRequest<any>[] = [];

  constructor(private loaderService: LoadingPageService, private authService: AuthService, private router: Router) { }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.requests.push(req);
    this.loaderService.isLoading.next(true);

    return new Observable(observer => {

      const subscription = next.handle(req)
        .subscribe(
          event => {
            // console.log("Retornou", event);
            if (event instanceof HttpResponse) {
              this.removeRequest(req);
              observer.next(event);
            }
          },
          err => {

            // console.log("error, event);
            this.removeRequest(req);
            observer.error(err);

          },
          () => {
            // console.log("other", event);
            this.removeRequest(req);
            observer.complete();
          });

      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };

    });

  }

}
